import { Badge } from "@/components/ui/badge";
import type { CyFunLevel } from "@/types/risk-analysis";
import { getCyFunLevelData } from "@/utils/risk-calculator";
import { cn } from "@/lib/utils";

type CyFunLevelBadgeProps = {
  level: CyFunLevel;
  size?: "sm" | "md";
  className?: string;
};

const SIZE_CLASSES: Record<"sm" | "md", string> = {
  sm: "text-xs px-2 py-0.5",
  md: "md:px-5 px-3 py-3",
};

export function CyFunLevelBadge({
  level,
  size = "md",
  className,
}: CyFunLevelBadgeProps) {
  const { label, color } = getCyFunLevelData(level);

  return (
    <Badge
      className={cn(
        color,
        "rounded-none border-0 font-bold",
        SIZE_CLASSES[size],
        className
      )}
      variant="outline"
    >
      {label}
    </Badge>
  );
}
